import React from 'react'
import st from './Contact.module.css'

const Contact = () => {
  return (
    <div className={st.container}>
        Contact form
    </div>
  )
}

export default Contact